import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentMethodAlmaIcon = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="106"
        height="32"
        viewBox="0 0 106 32"
        preserveAspectRatio="xMidYMid meet"
      >
        <title>Alma</title>
        <g
          fill="#FA5022"
          transform="translate(0,32) scale(0.1,-0.1)"
          stroke="none"
        >
          <path
            d="M119 290 c-9 -5 -21 -22 -27 -37 -11 -28 -62 -207 -62 -217 0 -16 42
-3 64 19 33 33 79 33 110 0 28 -30 70 -35 62 -7 -3 9 -17 60 -31 112 -32 119
-68 158 -116 130z m56 -87 c28 -94 30 -88 -25 -88 -28 0 -50 2 -50 5 0 6 27
97 35 118 9 24 28 7 40 -35z"
          />
          <path
            d="M330 160 c0 -123 1 -130 20 -130 19 0 20 7 20 130 0 123 -1 130 -20
130 -19 0 -20 -7 -20 -130z"
          />
          <path
            d="M494 228 c-32 -15 -44 -51 -44 -128 0 -68 1 -70 25 -70 23 0 24 3 27
78 3 73 4 77 27 80 36 6 51 -22 51 -95 0 -56 2 -63 20 -63 18 0 20 7 20 63 0
73 15 101 51 95 23 -3 24 -7 27 -80 3 -75 4 -78 27 -78 24 0 25 2 25 78 0 85
-15 115 -63 127 -26 7 -77 -10 -77 -25 0 -5 -15 -1 -32 10 -36 22 -53 24 -84
8z"
          />
          <path
            d="M862 224 c-34 -23 -55 -71 -48 -109 15 -77 84 -115 137 -76 25 19 30
20 35 6 3 -8 15 -15 25 -15 17 0 19 9 19 100 l0 100 -25 0 c-14 0 -25 -5 -25
-10 0 -6 -13 -4 -30 5 -37 19 -60 19 -88 -1z m100 -51 c39 -35 11 -103 -43
-103 -29 0 -59 31 -59 60 0 50 64 78 102 43z"
          />
        </g>{' '}
      </svg>
    </SvgIcon>
  );
};

export default PaymentMethodAlmaIcon;
